module.exports = __webpack_public_path__ + "static/media/julia.0d9f792c.jpg";